import { HttpHeaders } from '@angular/common/http';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/internal/operators';
import * as i0 from "@angular/core";
import * as i1 from "./authentication.service";
import * as i2 from "@angular/common/http";
import * as i3 from "@angular/router";
export class HttpService {
    constructor(authService, http, router) {
        this.authService = authService;
        this.http = http;
        this.router = router;
    }
    get(url) {
        return this.http.get(url, this.getAuthHeader()).pipe(catchError(err => {
            if (err.status === 808) {
                // refresh the access token and pass the 808 up to the calling method
                return this.authService.refreshAccessToken().pipe(map(success => {
                    throw err;
                }), catchError(error => {
                    if (error.status !== 808) {
                        //this.router.navigate(['/login']);
                        return of(null);
                    }
                    throw error;
                }));
            }
            else {
                throw err;
            }
        }));
    }
    put(url, body) {
        return this.http.put(url, JSON.stringify(body), this.getAuthHeader()).pipe(catchError(err => {
            if (err.status === 808) {
                // refresh the access token and pass the 808 up to the calling method
                return this.authService.refreshAccessToken().pipe(map(success => {
                    throw err;
                }), catchError(error => {
                    if (error.status !== 808) {
                        //this.router.navigate(['/login']);
                        return of(null);
                    }
                    throw error;
                }));
            }
            else {
                throw err;
            }
        }));
    }
    post(url, body) {
        return this.http.post(url, JSON.stringify(body), this.getAuthHeader()).pipe(catchError(err => {
            if (err.status === 808) {
                // refresh the access token and pass the 808 up to the calling method
                return this.authService.refreshAccessToken().pipe(map(success => {
                    throw err;
                }), catchError(error => {
                    if (error.status !== 808) {
                        //this.router.navigate(['/login']);
                        return of(null);
                    }
                    throw error;
                }));
            }
            else {
                throw err;
            }
        }));
    }
    getAuthHeader() {
        let headers = new HttpHeaders();
        //headers = headers.append('Content-Type', 'application/json');
        headers = headers.append('Authorization', `Bearer ${this.authService.getAccessToken()}`);
        return { headers: headers };
    }
}
HttpService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function HttpService_Factory() { return new HttpService(i0.ɵɵinject(i1.AuthenticationService), i0.ɵɵinject(i2.HttpClient), i0.ɵɵinject(i3.Router)); }, token: HttpService, providedIn: "root" });
